export default __webpack_public_path__ + "static/media/faq.a6ba8f76.png";